import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { UUID } from "angular2-uuid";
import { Subject } from "rxjs";
import { first, takeUntil } from "rxjs/operators";
import { Role } from "src/app/auth/models/role";
import { PhoneNumberRegexString } from "src/app/shared/regex/regexes";
import { UserViewModel } from "../../../auth/models/user.viewmodel";
import { UserService } from "../../../auth/user.service";
import { ToastService } from "../../../shared/toast.service";

@Component({
  selector: "app-add-user",
  templateUrl: "./addUser.component.html",
  styleUrls: ["./addUser.component.scss"],
  providers: [ToastService],
})
export class AddUserComponent implements OnInit, OnDestroy {
  addUserForm: FormGroup;
  @Output() UserAdded: EventEmitter<boolean> = new EventEmitter<boolean>();
  userRole: Role[] = [];
  selectedRole: string[] = [];
  selectedRoleIds: string[] = [];
  saveButtonActive: boolean;

  constructor(
    private _userService: UserService,
    private _toastService: ToastService
  ) {}
  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  ngOnInit() {
    this.saveButtonActive = true;
    this.addUserForm = new FormGroup({
      firstNameInput: new FormControl("", [
        Validators.required,
        Validators.minLength(2),
      ]),
      lastNameInput: new FormControl("", [
        Validators.required,
        Validators.minLength(2),
      ]),
      mailInput: new FormControl("", [Validators.required, Validators.email]),
      telInput: new FormControl("", [
        Validators.required,
        Validators.pattern(PhoneNumberRegexString),
      ]),
      roleId: new FormControl(""),
    });

    this._userService
      .getUserRoles()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.userRole = res;
      });
  }

  dismiss(data: any) {
    var editUserModal = document.getElementById("addUserModal");

    if (data.target.id == "addUserModal" || data.target.id == "dismiss-btn") {
      editUserModal.style.display = "none";
      editUserModal.classList.remove("show");
      this.clearErrors();
      this.selectedRole = [];
    }
  }

  getSelectedRole(data: any, event: Event) {
    // only push when not exist or else remove
    // tODO refactor
    if (this.selectedRole.indexOf(data.roleName) == -1) {
      this.selectedRole.push(data.roleName);
      this.selectedRoleIds.push(data.roleId);
    } else {
      this.selectedRole = this.selectedRole.filter(
        (item) => item != data.roleName
      );
      this.selectedRoleIds = this.selectedRoleIds.filter(
        (item) => item != data.roleId
      );
    }
    const target = event.srcElement as HTMLInputElement;
    target.blur();
  }

  addUser() {
    // enabling input error messages
    Object.keys(this.addUserForm.controls).forEach((field) => {
      const control = this.addUserForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });

    var addUserModal = document.getElementById("addUserModal");
    var modalback = document.getElementsByClassName(
      "modal-backdrop"
    )[0] as HTMLElement;

    if (this.addUserForm.valid && this.selectedRole.length > 0) {
      var firstName = this.addUserForm.get("firstNameInput").value;
      var lastName = this.addUserForm.get("lastNameInput").value;
      var eMail = this.addUserForm.get("mailInput").value;
      var telInput = this.addUserForm.get("telInput").value;

      var userToAdd = new UserViewModel({
        id: UUID.UUID(),
        mail: eMail,
        firstName: firstName,
        lastName: lastName,
        tel: telInput,
        roleIds: this.selectedRoleIds,
      });

      this._userService
        .createUser(userToAdd)
        .pipe(first())
        .subscribe((res) => {
          this.clearErrors();
          this._toastService.showSuccesToast(
            $localize`:@@admin.user.added:User has been added!`,
            $localize`:@@admin.user.added2:User was added and a mail has been send!`
          );
          this.UserAdded.emit(true);

          this.selectedRole = [];
          this.selectedRoleIds = [];
          addUserModal.style.display = "none";
          modalback.style.display = "none";
          addUserModal.classList.remove("show");
        });
    } else if (this.selectedRole.length == 0) {
      this._toastService.showErrorToast(
        $localize`:@@validation.filloutform:Please fill out the form!`,
        $localize`:@@validation.selectuserrole:Please select a userRole!`
      );
    } else {
      this._toastService.showErrorToast(
        $localize`:@@validation.filloutform:Please fill out the form!`,
        $localize`:@@validation.entervalidinfo:Please enter valid information in the form!`
      );
    }
  }

  clearErrors() {
    this.addUserForm.reset();
    this.selectedRole = [];
  }

  get form() {
    return this.addUserForm.controls;
  }
}
